export function getCurrentFeatureSlug() {
  const urlObject = new URL(window.location.href)
  const pathSegments = urlObject.pathname.split('/').filter(Boolean)
  return pathSegments[0]
}
